import { TUser } from '../../types/user';
import { actionGenerator } from '../../utils/redux/actionGenerator';
import { EGetUserStatus } from './types';

export const setUserData = actionGenerator<EGetUserStatus.SetUserData, TUser>(EGetUserStatus.SetUserData);
